export function objectComparatorFactory<T>(key: string): (a: T, b: T) => boolean {
    return (a: T, b: T) =>
        a === b
        || (
            (a && b) && (a[key] === b[key])
        );
}


// WEBPACK FOOTER //
// ./src/app/shared/utils/object-comparator.util.ts